import api from 'service/api'

const dponetAPI = api.create('dponet')
const dponetAPINotTreat = api.create('dponet', false)

const get = async ({ userId = '', ...params }) => {
  return await dponetAPI.get(`/backoffice/users/${userId}`, { params })
}

const create = async ({ ...data }) => {
  return await dponetAPI.post('/backoffice/users', data)
}

const update = async ({ userId = '', ...data }) => {
  return await dponetAPI.put(`/backoffice/users/${userId}`, data)
}

const permissions = async () => {
  return await dponetAPI.get('/backoffice/users/permissions')
}

const changeStatus = async ({ userId }) => {
  return await dponetAPINotTreat.put(
    `/backoffice/users/${userId}/change_status`,
  )
}

const generateTemporaryPassword = async (userId) => {
  return await dponetAPI.put(
    `/backoffice/users/${userId}/generate_temporary_password`,
  )
}

const users = {
  get,
  create,
  update,
  permissions,
  changeStatus,
  generateTemporaryPassword,
}

export default users
